import _toConsumableArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Summary from "./Summary";
import { useAuth } from "@qure/qure-auth";
import { useEffect, useMemo, useState } from "react";
import ReminderList from "./ReminderList";
import useGetPatientReminders from "../PatientReminder/services/getpatientReminders";
import useGetPatientSummary from "./services/useGetPatientSummary";
import useCreatePatientSummary from "./services/useCreatePatientSummary";
import { get, isEmpty } from "lodash";
import { useStoreState } from "pullstate";
import Store from "../../utils/Store";
import { faAnglesLeft } from "@fortawesome/pro-regular-svg-icons";
import ExpandCollapseButton from "../common/ExpandCollapseButton";
import { trackEvent } from "../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../utils/mixpanelEvents";
import CreateEditReminder from "./CreateEditReminder";
import { useContext } from "react";
import { PatientsContext } from "../Patients/PatientsContext";
import { useTranslation } from "react-i18next";
import ACRSubmission from "../ACRSubmissions";
import { DEFAULT_LINKED_RESOURCES } from "../PatientReminder/constants";
import ACRStore from "../../utils/ACRStore";
import { useGetWorkspaceConfig } from "../ACRSubmissions/services";
import { findSubmissionWithUnsavedChanges, clearMinimizedForPatient } from "../../utils/acrStoreUtils";
import { PatientTaskModal } from "./PatientTaskModal";
import { useSelectedPatientStore } from "@/stores/selected-patient";
import Toast from "../Toast";
export var VIEWS = {
  SUMMARY: "summary",
  REMINDERS: "reminders",
  CREATE_EDIT_REMINDER: "create_edit_reminder",
  ACR: "ACR"
};
var SummarySection = function SummarySection(_ref) {
  var _patient$patient_uid;
  var reminders = _ref.reminders,
    setRemindersData = _ref.setRemindersData,
    patientTags = _ref.patientTags,
    customFields = _ref.customFields,
    onToggleTags = _ref.onToggleTags,
    isTagsExpanded = _ref.isTagsExpanded,
    patient = _ref.patient,
    wsSummaryData = _ref.wsSummaryData,
    setWsSummaryData = _ref.setWsSummaryData,
    workspaceId = _ref.workspaceId,
    onRestoreToNavigation = _ref.onRestoreToNavigation;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useAuth = useAuth(),
    userInfo = _useAuth.userInfo;
  var patientUid = ((_patient$patient_uid = patient.patient_uid) === null || _patient$patient_uid === void 0 ? void 0 : _patient$patient_uid.toString()) || "";
  var patientId = patient.patient_id || "";
  var _useState = useState(VIEWS.SUMMARY),
    view = _useState[0],
    setView = _useState[1];
  var _useState2 = useState(null),
    summary = _useState2[0],
    setSummary = _useState2[1];
  var _useState3 = useState(null),
    selectedReminder = _useState3[0],
    setSelectedReminder = _useState3[1];
  var _useState4 = useState(null),
    selectedReminderForModal = _useState4[0],
    setSelectedReminderForModal = _useState4[1];
  var _useState5 = useState(false),
    isTaskModalMinimized = _useState5[0],
    setIsTaskModalMinimized = _useState5[1];
  var setSelectedPatient = useSelectedPatientStore(function (s) {
    return s.setSelectedPatient;
  });
  var _useState6 = useState(false),
    hasTriggeredSummaryCreation = _useState6[0],
    setHasTriggeredSummaryCreation = _useState6[1];
  var _useState7 = useState(null),
    externalSubmissionToOpen = _useState7[0],
    setExternalSubmissionToOpen = _useState7[1];
  var _ref2 = useContext(PatientsContext),
    getSuggestedNextSteps = _ref2.getSuggestedNextSteps,
    userWorkspaces = _ref2.userWorkspaces;
  var _useStoreState = useStoreState(ACRStore, function (s) {
      var _s$metadata, _s$metadata2;
      return {
        submissionToOpen: (s === null || s === void 0 || (_s$metadata = s.metadata) === null || _s$metadata === void 0 ? void 0 : _s$metadata.submissionToOpen) || null,
        shouldNavigateToSummary: (s === null || s === void 0 || (_s$metadata2 = s.metadata) === null || _s$metadata2 === void 0 ? void 0 : _s$metadata2.shouldNavigateToSummary) || false
      };
    }),
    submissionToOpen = _useStoreState.submissionToOpen,
    shouldNavigateToSummary = _useStoreState.shouldNavigateToSummary;
  var _useStoreState2 = useStoreState(Store, function (store) {
      return {
        selectedNextStep: store.selectedNextStep,
        isSummaryCollapsed: store.isSummaryCollapsed,
        initialSummaryView: store.initialSummaryView,
        isSupportWidgetMinimized: store.isSupportWidgetMinimized,
        worklistFilterDiscardToken: store.worklistFilterDiscardToken
      };
    }),
    selectedNextStep = _useStoreState2.selectedNextStep,
    isSummaryCollapsed = _useStoreState2.isSummaryCollapsed,
    initialSummaryView = _useStoreState2.initialSummaryView,
    isSupportWidgetMinimized = _useStoreState2.isSupportWidgetMinimized,
    worklistFilterDiscardToken = _useStoreState2.worklistFilterDiscardToken;
  useEffect(function () {
    if (view !== VIEWS.CREATE_EDIT_REMINDER) setSelectedReminder(null);
  }, [view]);
  var reserveSpaceForMinimizedSupport = isSupportWidgetMinimized && !isSummaryCollapsed;

  // Get workspace ID for ACR submissions
  var getACRWorkspaceId = function getACRWorkspaceId() {
    var _userWorkspaces$find;
    if (!patient.source_id || isEmpty(userWorkspaces)) {
      return workspaceId;
    }
    var acrWorkspaceId = userWorkspaces === null || userWorkspaces === void 0 || (_userWorkspaces$find = userWorkspaces.find(function (workspace) {
      return workspace.uuid === patient.source_id;
    })) === null || _userWorkspaces$find === void 0 ? void 0 : _userWorkspaces$find.id;
    return acrWorkspaceId;
  };
  var acrWorkspaceId = getACRWorkspaceId();
  useGetWorkspaceConfig({
    workspaceId: acrWorkspaceId,
    enabled: !!acrWorkspaceId
  });
  var isACREnabled = get(userInfo, ["settings", "ui_settings", "is_acr_enabled"], false);
  var _useGetPatientReminde = useGetPatientReminders(patientUid),
    _useGetPatientReminde2 = _useGetPatientReminde.data,
    _remindersData = _useGetPatientReminde2 === void 0 ? [] : _useGetPatientReminde2,
    _refetchReminders = _useGetPatientReminde.refetch,
    isSuccess = _useGetPatientReminde.isSuccess;
  var _useGetPatientSummary = useGetPatientSummary(workspaceId, patientUid),
    _useGetPatientSummary2 = _useGetPatientSummary.data,
    summaryData = _useGetPatientSummary2 === void 0 ? {} : _useGetPatientSummary2,
    isSummarySuccess = _useGetPatientSummary.isSuccess,
    isSummaryLoading = _useGetPatientSummary.isLoading,
    isSummaryError = _useGetPatientSummary.isError,
    refetchSummary = _useGetPatientSummary.refetch,
    isSummaryFetching = _useGetPatientSummary.isFetching;

  // Get timezone info
  var tzInfo = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // Initialize create summary mutation
  var createSummaryMutation = useCreatePatientSummary(workspaceId, patientUid, tzInfo);
  useEffect(function () {
    if (isSummarySuccess) {
      setSummary(summaryData);
    }
  }, [isSummarySuccess, summaryData]);
  useEffect(function () {
    if (selectedNextStep && selectedNextStep.type === "reminder") {
      var reminderAction = selectedNextStep.action;
      setSelectedReminder({
        id: 0,
        context: reminderAction.context,
        remind_after: reminderAction.remind_after,
        linked_resources: _objectSpread(_objectSpread({}, DEFAULT_LINKED_RESOURCES), reminderAction.appointmentId && {
          appointments: [reminderAction.appointmentId]
        })
      });
      setView(VIEWS.CREATE_EDIT_REMINDER);
      Store.update(function (s) {
        s.selectedNextStep = null;
        s.isSummaryCollapsed = false;
      });
    }
  }, [selectedNextStep]);

  // Handle initial summary view from store (e.g., when navigating from ReminderCountBadge)
  useEffect(function () {
    if (initialSummaryView) {
      setSelectedReminder(null);
      if (initialSummaryView === VIEWS.CREATE_EDIT_REMINDER) {
        setView(VIEWS.CREATE_EDIT_REMINDER);
      }
      if (initialSummaryView === VIEWS.REMINDERS) {
        setView(VIEWS.REMINDERS);
      }
      // Clear the initial view after applying it
      Store.update(function (s) {
        s.initialSummaryView = null;
      });
    }
  }, [initialSummaryView]);
  useEffect(function () {
    if (isSuccess) {
      setRemindersData(_remindersData);
    }
  }, [_remindersData, isSuccess]);

  // Transform WebSocket summary data to match SummaryData type
  var wsFormattedSummary = useMemo(function () {
    if (wsSummaryData && wsSummaryData.patient_id === patient.patient_uid) {
      return {
        id: "ws_".concat(wsSummaryData.patient_id),
        patient_id: wsSummaryData.patient_id.toString(),
        summary: wsSummaryData.summary,
        additional: {},
        created_at: wsSummaryData.last_updated_at,
        updated_at: wsSummaryData.last_updated_at
      };
    }
    return null;
  }, [wsSummaryData, patient.patient_uid]);
  var refreshSummary = function refreshSummary() {
    trackEvent(MIXPANEL_EVENTS.CASE_SNAPSHOT_REGENERATED);
    setWsSummaryData === null || setWsSummaryData === void 0 || setWsSummaryData(null);
    setSummary(null);
    createSummaryMutation.mutateAsync();
  };

  // Reset the trigger flag and close any open/minimized task modal when patient changes
  useEffect(function () {
    setHasTriggeredSummaryCreation(false);
    setSelectedReminderForModal(null);
    setIsTaskModalMinimized(false);
    return onBackToSummary;
  }, [patientUid]);

  // Mirror the minimized-task state into the global Store so the worklist can
  // block patient switching (and show the unsaved-changes modal) while a task
  // is minimized. Reuses the same guard as tag-edit / reminder-form.
  useEffect(function () {
    var hasMinimizedTask = isTaskModalMinimized && !!selectedReminderForModal;
    Store.update(function (s) {
      s.isPatientTaskMinimized = hasMinimizedTask;
    });
  }, [isTaskModalMinimized, selectedReminderForModal]);

  // Clear the guard flag if the summary section unmounts (e.g. leaving the page)
  useEffect(function () {
    return function () {
      Store.update(function (s) {
        s.isPatientTaskMinimized = false;
      });
    };
  }, []);

  // Close the task modal when the user discards it to apply a worklist filter change
  useEffect(function () {
    if (!worklistFilterDiscardToken) return;
    setSelectedReminderForModal(null);
    setIsTaskModalMinimized(false);
  }, [worklistFilterDiscardToken]);

  // Reset view to summary when ACR is disabled for the new patient
  useEffect(function () {
    if (view === VIEWS.ACR && !isACREnabled) {
      setView(VIEWS.SUMMARY);
    }
  }, [view, isACREnabled]);

  // Auto-create summary if it's empty
  useEffect(function () {
    // Check if summary has loaded and is empty, and we haven't already triggered creation
    if (isSummarySuccess && !isSummaryLoading && !isSummaryFetching && isEmpty(summaryData) && !hasTriggeredSummaryCreation && workspaceId && patientUid && !createSummaryMutation.isLoading) {
      setHasTriggeredSummaryCreation(true);
      createSummaryMutation.mutateAsync();
    }
  }, [summaryData, isSummarySuccess, isSummaryLoading, isSummaryFetching, hasTriggeredSummaryCreation, workspaceId, patientUid]);
  var onAddNewReminder = function onAddNewReminder() {
    trackEvent(MIXPANEL_EVENTS.REMINDER_CREATE_OPENED);
    setView(VIEWS.CREATE_EDIT_REMINDER);
  };
  var onEditReminder = function onEditReminder(reminder) {
    trackEvent(MIXPANEL_EVENTS.REMINDER_EDIT_OPENED);
    setSelectedPatient({
      patient_uid: patient.patient_uid,
      source_id: patient.source_id
    });
    setIsTaskModalMinimized(false);
    setSelectedReminderForModal(reminder);
  };
  var onCloseCreateEditModal = function onCloseCreateEditModal() {
    setSelectedReminder(null);
    setView(VIEWS.REMINDERS);
  };

  // Listen for external requests to open submissions (from minimized cards)
  useEffect(function () {
    if (submissionToOpen) {
      var storeState = ACRStore === null || ACRStore === void 0 ? void 0 : ACRStore.getRawState();

      // Only process if it's for the current patient
      if ((storeState === null || storeState === void 0 ? void 0 : storeState.currentPatientId) === patientId) {
        // Switch to ACR view and pass submission to open
        setView(VIEWS.ACR);
        setExternalSubmissionToOpen(submissionToOpen);

        // Clear the flag
        ACRStore === null || ACRStore === void 0 || ACRStore.update(function (store) {
          if (store.metadata) {
            delete store.metadata.submissionToOpen;
          }
        });
      }
    }
  }, [submissionToOpen, patientId]);

  // Listen for navigation back to summary (from unsaved changes modal)
  useEffect(function () {
    if (shouldNavigateToSummary) {
      // Navigate to summary view
      setView(VIEWS.SUMMARY);

      // Clear the flag
      ACRStore.update(function (store) {
        if (store.metadata) {
          delete store.metadata.shouldNavigateToSummary;
        }
      });
    }
  }, [shouldNavigateToSummary]);
  var onBackToSummary = function onBackToSummary() {
    // Check if there are unsaved changes in any ACR submission
    var submissionWithChanges = findSubmissionWithUnsavedChanges(patientId);
    if (submissionWithChanges) {
      // Set pending back to summary in store
      ACRStore.update(function (store) {
        store.pendingBackToSummary = {
          patientId: patientId,
          submissionId: submissionWithChanges
        };
      });
      return;
    }

    // No unsaved changes, clear minimized submissions and proceed with navigation
    clearMinimizedForPatient(patientId);
    trackEvent(MIXPANEL_EVENTS.CASE_SNAPSHOT_VIEW_OPENED);
    setView(VIEWS.SUMMARY);
  };

  // Sort reminders by remind_after date
  var sortedReminders = useMemo(function () {
    return _toConsumableArray(reminders).sort(function (a, b) {
      return new Date(a.remind_after).getTime() - new Date(b.remind_after).getTime();
    });
  }, [reminders]);
  var sortedUnresolvedReminders = useMemo(function () {
    return _toConsumableArray(reminders).filter(function (reminder) {
      return !reminder.resolved;
    }).sort(function (a, b) {
      return new Date(a.remind_after).getTime() - new Date(b.remind_after).getTime();
    });
  }, [reminders]);

  // Rendered in both collapsed and expanded states so the minimized task card
  // (a portal) stays visible across the Navigation/Records/Studies sections.
  var taskModal = /*#__PURE__*/React.createElement(PatientTaskModal, {
    reminder: selectedReminderForModal,
    patientUid: patientUid,
    isMinimized: isTaskModalMinimized,
    onMinimize: function onMinimize() {
      return setIsTaskModalMinimized(true);
    },
    onRestore: function onRestore() {
      setIsTaskModalMinimized(false);
      onRestoreToNavigation === null || onRestoreToNavigation === void 0 || onRestoreToNavigation();
    },
    onClose: function onClose() {
      setSelectedReminderForModal(null);
      setIsTaskModalMinimized(false);
    },
    onResolved: function onResolved() {
      _refetchReminders();
      setSelectedReminderForModal(null);
      setIsTaskModalMinimized(false);
    },
    onSaved: function onSaved(updatedReminder) {
      setSelectedReminderForModal(updatedReminder);
      _refetchReminders();
    },
    actions: {
      onTaskCreated: function onTaskCreated(message) {
        return Toast.success(message);
      },
      onUpdateTags: function onUpdateTags() {
        setIsTaskModalMinimized(true);
        if (!isTagsExpanded) onToggleTags === null || onToggleTags === void 0 || onToggleTags();
      },
      onCreateTask: function onCreateTask() {
        setIsTaskModalMinimized(true);
        onAddNewReminder();
      },
      onGenerateCommunication: function onGenerateCommunication(letterTemplateId) {
        setIsTaskModalMinimized(true);
        Store.update(function (s) {
          s.selectedNextStep = {
            type: "letter",
            action: {
              letter_id: letterTemplateId !== null && letterTemplateId !== void 0 ? letterTemplateId : 0
            }
          };
        });
      },
      onCompleteForm: function onCompleteForm(formId) {
        setIsTaskModalMinimized(true);
        Store.update(function (s) {
          s.selectedNextStep = {
            type: "form",
            action: {
              id: formId !== null && formId !== void 0 ? formId : 0,
              response: {}
            }
          };
        });
      },
      onAddNote: function onAddNote() {
        setIsTaskModalMinimized(true);
        Store.update(function (s) {
          s.selectedNextStep = {
            type: "note"
          };
        });
      }
    }
  });
  if (isSummaryCollapsed) {
    // Collapsed state - show only expand button
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col h-full bg-gray-100 dark:bg-gray-900 border-l border-gray-200 dark:border-gray-700 transition-all duration-500 ease-in-out overflow-visible"
    }, /*#__PURE__*/React.createElement("div", {
      className: "py-3 dark:bg-gray-800 flex items-center justify-center"
    }, /*#__PURE__*/React.createElement(ExpandCollapseButton, {
      onClick: function onClick() {
        trackEvent(MIXPANEL_EVENTS.CASE_SNAPSHOT_EXPANDED);
        Store.update(function (s) {
          s.isSummaryCollapsed = false;
        });
      },
      title: t("expand_summary"),
      icon: faAnglesLeft
    }))), taskModal);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col border-l overflow-visible bg-gray-50 dark:bg-gray-900 border-gray-200 dark:border-gray-700 transition-all duration-500 ease-in-out ".concat(reserveSpaceForMinimizedSupport ? "min-h-0" : "h-full"),
    style: reserveSpaceForMinimizedSupport ? {
      height: "calc(100% - 53px)"
    } : undefined
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-full min-h-0 flex flex-col animate-expandSummary"
  }, view === VIEWS.SUMMARY && /*#__PURE__*/React.createElement(Summary, {
    latestReminder: sortedUnresolvedReminders[0],
    remindersCount: sortedReminders.length,
    unresolvedRemindersCount: sortedUnresolvedReminders.length,
    patientTags: patientTags,
    customFields: customFields,
    showReminders: function showReminders() {
      trackEvent(MIXPANEL_EVENTS.REMINDERS_LIST_OPENED);
      setView(VIEWS.REMINDERS);
    },
    onOpenLatestReminder: function onOpenLatestReminder() {
      trackEvent(MIXPANEL_EVENTS.REMINDERS_LIST_OPENED);
      setView(VIEWS.REMINDERS);
      var latest = sortedUnresolvedReminders[0];
      if (latest) onEditReminder(latest);
    },
    showACRSubmission: function showACRSubmission() {
      return setView(VIEWS.ACR);
    },
    onToggleTags: onToggleTags,
    isTagsExpanded: isTagsExpanded,
    summary: wsFormattedSummary || summary,
    onRefreshSummary: refreshSummary,
    onRefetchSummary: refetchSummary,
    isSummaryLoading: isSummaryFetching || createSummaryMutation.isLoading,
    isSummaryGenerating: !wsFormattedSummary && !summary && createSummaryMutation.isSuccess,
    hasError: isSummaryError,
    isACREnabled: isACREnabled
  }), view === VIEWS.REMINDERS && /*#__PURE__*/React.createElement(ReminderList, {
    data: sortedReminders,
    patient_uid: patientUid,
    onAddNewReminder: onAddNewReminder,
    onEditReminder: onEditReminder,
    onBackToSummary: onBackToSummary,
    refetchReminders: _refetchReminders,
    workspaceId: workspaceId,
    activeReminderId: selectedReminderForModal === null || selectedReminderForModal === void 0 ? void 0 : selectedReminderForModal.id
  }), view === VIEWS.ACR && isACREnabled && /*#__PURE__*/React.createElement(ACRSubmission, {
    patientId: patientId,
    workspaceId: acrWorkspaceId,
    onBackToSummary: onBackToSummary,
    externalSubmissionToOpen: externalSubmissionToOpen,
    onExternalSubmissionOpened: function onExternalSubmissionOpened() {
      return setExternalSubmissionToOpen(null);
    }
  }), view === VIEWS.CREATE_EDIT_REMINDER && /*#__PURE__*/React.createElement(CreateEditReminder, {
    patientUid: patientUid,
    onCloseCreateEditModal: onCloseCreateEditModal,
    selectedReminder: selectedReminder,
    workspaceId: workspaceId,
    refetchReminders: function refetchReminders() {
      _refetchReminders();
      getSuggestedNextSteps();
    }
  })), taskModal);
};
export default SummarySection;